import { render } from "./benefits.vue?vue&type=template&id=c2c02144"
import script from "./benefits.vue?vue&type=script&lang=js"
export * from "./benefits.vue?vue&type=script&lang=js"

import "./benefits.vue?vue&type=style&index=0&id=c2c02144&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__